export default "__VITE_ASSET__BsTEBlK2__"